import miniLibraryServices from '../services/miniLibraryServices';
import { ServerAlertAction } from '../../common'
import { MiniLibraryBody } from '../types/MiniLibraryBody';
import { MiniLibraryActions } from '../types/MiniLibraryActions';
import MiniLibraryDetails from '../types/MiniLibraryDetails';

const miniLibraryList = () => (dispatch: any) => {
	const success = (data: MiniLibraryBody[]): MiniLibraryActions => ({
		type: 'MINI_LIBRARY_LIST_SUCCESS', data
	});

	miniLibraryServices.list()
		.then((res: any) => dispatch(success(res)))
}

const getMiniLibraryCount = () => (dispatch: any) => {
	const success = (data: number): MiniLibraryActions => ({
		type: 'MINI_LIBRARY_COUNT_SUCCESS', data
	});

	miniLibraryServices.count()
		.then((res: any) => dispatch(success(res)))
}

const miniLibraryDetails = (reqBody: any) => (dispatch: any) => {
	const success = (data: MiniLibraryDetails): MiniLibraryActions => ({
		type: 'MINI_LIBRARY_DETAILS_DATA', data
	});

	miniLibraryServices.miniLibraryDetails(reqBody)
		.then((res: any) => dispatch(success(res)))
}

const showMsg = (msg: string, vari: any) => {
	let showAlert = (message: string, variant: 'error' | 'success' = 'error'): ServerAlertAction => ({
		type: 'SHOW_ALERT', data: { message: message, variant: variant, openSnackbar: true }
	})
	return (dispatch: any) => {
		dispatch(showAlert(msg, vari));
	}
}

export {
	miniLibraryList,
	getMiniLibraryCount,
	miniLibraryDetails,
	showMsg
};